<template>
  <layout-vendor-dashboard-inner
    :vendor-id="vendorId"
    :back-link="{ name: 'company-vendorId-dashboard-products', params: { vendorId } }">
    <div class="vendor-deal-create">
      <div v-show="!showLoadDealUi" class="animate__fadeIn animate--fast">
        <div class="margin-m-bottom flex flex-wrap gap-m">
          <form-button
            icon="refresh"
            text="justopp.vendorDealCreate.loadExistingUiCta"
            @click="showLoadDealUi = true"></form-button>
          <form-button
            icon="x"
            text="justopp.vendorDealCreate.clearFormCta"
            theme="danger"
            @click="clearForm()"></form-button>
        </div>
        <span
          >*
          {{ translateUcFirst("justopp.vendorDealCreate.loadExistingUiExplain") }}</span
        >
      </div>

      <h6 v-show="showLoadDealUi" @click="showLoadDealUi = false">
        <icon-text
          class="cursor-pointer animate__fadeIn animate--fast"
          text="justopp.vendorDealCreate.loadExistingUiCloseCta"
          icon="x"></icon-text>
      </h6>
      <div v-show="showLoadDealUi" class="past-deal-ui animate__fadeIn animate--fast">
        <div class="flex gap-m flex-top">
          <div class="max-width-300">
            <form-input
              v-model="baseProductId"
              v-bind="dealSelectFieldConfig"></form-input>
          </div>
          <form-button
            icon="clone"
            :theme="baseProductId && baseProductId != '' ? 'lead' : 'gray'"
            :disabled="baseProductId && baseProductId != '' ? null : true"
            text="justopp.vendorDealCreate.loadExistingCta"
            @click="loadPastProduct(baseProductId)"></form-button>
        </div>
        <p class="text-s max-width-600 margin-m-top margin-xl-bottom">
          {{ translateUcFirst("justopp.vendorDealCreate.loadExistingFieldHint") }}
        </p>
        <hr />
      </div>

      <crud-create
        ref="crudCreate"
        v-bind="createConfiguration"
        @item:updated="handleItemUpdated"></crud-create>
    </div>
  </layout-vendor-dashboard-inner>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import CrudCreate from "@/client/components/crud/customV1/Create.vue";
import vendorProductCreateFromConfigFactory from "@/client/applications/justopp/assets/static/forms/vendorProductFormFactory.js";
import Block from "@/client/components/base/frameworks/we/html/Block";

// TODO: backend: remember: assign owners, VendorId, other hard coded stuff
// TODO: add fields from excel sheet (plug, watt)
// TODO: load from older deals

export default {
  components: { Block, CrudCreate },
  layout: {
    component: "noContainer",
    params: {
      title: "justopp.vendorDealCreate.pageTitle",
      subTitle: "justopp.vendorDealCreate.pageSubtitle",
      containerClass: "margin-remove-vertical",
    },
  },
  middleware: {
    requireVendorOrAdmin: { vendorIdFromParam: "vendorId" },
  },
  meta: "justopp.vendorDealCreate.browserTitle",
  props: {
    // vendor ID
    vendorId: {
      type: String,
      default: 0,
    },
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },

  data() {
    let endDateTime = new Date();
    endDateTime.setDate(
      endDateTime.getDate() + config.justopp.auction.defaultDealDurationDays
    );

    let defaultInitialData = {
      typeList: ["justoppDeal", "auction"],
      AuctionProductType: {
        startDateTime: new Date(),
        endDateTime: endDateTime,
      },
    };
    let productDataCookieName = "saffron-justopp-product-create-FE-data";

    let initialDataWithCookieData = this.getProductDataFromCookie(
      productDataCookieName,
      defaultInitialData
    );

    return {
      productDataCookieName,
      showLoadDealUi: false,
      defaultInitialData,
      createConfiguration: {
        showTopSubmitButton: false,
        subject: "product",
        submitUrl: "justopp/deals",
        showCancelButton: false,
        initialItemData: { ...initialDataWithCookieData },
        cancelRedirect: {
          name: "company-vendorId-dashboard-products",
          params: { vendorId: this.vendorId },
        },
        successRedirect: {
          name: "company-vendorId-dashboard-products",
          params: { vendorId: this.vendorId },
        },
        formConfig: vendorProductCreateFromConfigFactory({
          vendorId: this.vendorId,
          userProfile: this.$store.getters["user/profile"],
        }),
      },
      baseProductId: false,
      dealSelectFieldConfig: {
        type: "select2",
        label: false,
        placeholder: "justopp.vendorDealCreate.loadExistingFieldPlaceholder",
        multiple: false,
        name: "dealSelect",
        asyncListSource: "justopp/deals",
        asyncListData: { filters: { VendorId: this.vendorId } },
        asyncListLive: true,
        asyncDataTextFilterParamName: "code",
        textFilterAsSaffronListFilter: true,
        asyncListParser: (list) => {
          return list.items.map((item) => ({
            value: item.id,
            label: item.code + " | " + item.name,
          }));
        },
        translateList: false,
      },
      asyncData: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    //  this.productForm.adjustTypes([], true);
  },
  mounted() {
    this.loadDataFromCookie();
  },
  activated() {
    this.loadDataFromCookie();
  },
  methods: {
    getProductDataFromCookie(cookieName, baseData) {
      if (!cookieName) {
        cookieName = this.productDataCookieName;
      }

      if (!baseData) {
        baseData = this.defaultInitialData;
      }

      let cookieData = this.$cookie.get(cookieName);
      if (!cookieData) {
        cookieData = {};
      }
      let finalData = { ...baseData, ...cookieData };
      return finalData;
    },
    loadDataFromCookie() {
      let finalData = this.getProductDataFromCookie();
      this.$refs.crudCreate.setItemData(finalData);
    },
    clearForm() {
      this.$refs.crudCreate.setItemData({ ...this.defaultInitialData });
    },
    setProductDataToCookie(data) {
      this.$cookie.set(this.productDataCookieName, data);
    },
    handleItemUpdated({ itemData }) {
      this.setProductDataToCookie(itemData);
    },
    async loadPastProduct(productId) {
      let itemResult = await this.asyncOps.asyncCall(
        `justopp/deals/${productId}`,
        {},
        {
          method: "get",
          withUi: "justopp.vendorDealCreate.baseDealLoadedSuccess",
        }
      );

      /*
       itemResult.data.item.name =
       itemResult.data.item.name +
       " (" +
       this.translate("justopp.vendorDealCreate.nameCopy") +
       ")";
       */

      // clean ID and type ID
      if (itemResult.data.item.JustoppDealProductType) {
        delete itemResult.data.item.id;
        delete itemResult.data.item.price;
        delete itemResult.data.item.AuctionProductType.startingPrice;
        delete itemResult.data.item.JustoppDealProductType.minimumQuantity;
        delete itemResult.data.item.JustoppDealProductType.maximumQuantity;

        itemResult.data.item.JustoppDealProductType.isSold = "false";
      }
      this.$refs.crudCreate.setItemData(itemResult.data.item);
      this.showLoadDealUi = false;
    },
  },
};
</script>

<style lang="scss">
.vendor-deal-create {
  .form {
    .fields {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .top-block {
        order: 100;
        flex: 0 0 100%;
      }

      .form__fieldset {
        //   flex: 0 0 48%;

        //  @media (max-width: 1024px) {
        //    flex: 0 0 100%;
        //  }
        //
        //  &.translations {
        //   flex: 0 0 100%;
        // }
      }
    }
  }
}
</style>

<style lang="scss" scoped></style>
